import { DOMAIN_COLOR_PALETTE, DOMAIN_COLOR_PALETTE_MUTED } from "../../constants";

/**
 * Детерминированно определяет цвет домена на основе его названия
 * Использует простой хеш для стабильного выбора цвета
 * @param muted — при true используется приглушённая палитра (для списка задач)
 */
export const getDomainColor = (domain: string | null | undefined, muted = false): string => {
  if (!domain) {
    return "bg-neutral-light text-neutral-text border border-neutral-border";
  }

  const palette = muted ? DOMAIN_COLOR_PALETTE_MUTED : DOMAIN_COLOR_PALETTE;
  let hash = 0;
  for (let i = 0; i < domain.length; i++) {
    const char = domain.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  const colorIndex = Math.abs(hash) % palette.length;
  return palette[colorIndex];
};

/**
 * Создаёт карту цветов для списка доменов
 * @param muted — при true используется приглушённая палитра (для страницы списка задач)
 */
export const createDomainColorMap = (domains: string[], muted = false): Record<string, string> => {
  const map: Record<string, string> = {};
  domains.forEach(domain => {
    if (domain && !map[domain]) {
      map[domain] = getDomainColor(domain, muted);
    }
  });
  return map;
};

